export const rutgersTabsStyles = (theme) => ({
  root: {
    height: 35,
    minHeight: 35,
    backgroundColor: ({ level2 = false }) =>
      level2
        ? theme.palette.components.tabBackgroundLevel2
        : theme.palette.components.tabBackground,
  },
  indicator: {
    width: '100%',
    backgroundColor: theme.color.rutgersRed,
  },
})

export const rutgersTabStyles = (theme) => ({
  root: {
    overflowY: 'hidden',
    display: 'flex',
    flex: '1',
    minHeight: 35,
    height: 35,
    minWidth: 30,
    width: 30,
    paddingLeft: 0,
    paddingRight: 0,
    fontWeight: 400,
    fontSize: '14px',
    color:
      theme.palette.type === 'dark'
        ? theme.color.whitesmoke
        : theme.color.darkerRed,
    opacity: 1,
    lineHeight: 1.2,
    '& .MuiTypography-root': {
      fontWeight: 'inherit',
    },
    '&$selected': {
      color:
        theme.palette.type === 'dark'
          ? theme.color.white
          : theme.color.rutgersRed,
      fontWeight: 700,
    },
  },
  selected: {},
})
